import { render, staticRenderFns } from "./ClusterSpotsModal.vue?vue&type=template&id=808e0828&scoped=true&"
import script from "./ClusterSpotsModal.vue?vue&type=script&lang=js&"
export * from "./ClusterSpotsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClusterSpotsModal.vue?vue&type=style&index=0&id=808e0828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e0828",
  null
  
)

export default component.exports